import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { BodyDatosExpedienteComponent } from '../body-datos-expediente/body-datos-expediente.component';
import { RegistroDocumentoComponent } from '../../registro-documento/registro-documento.component';
import { FurService } from 'src/app/services/fur.service';
import { ContenedorWebComponent } from '../../formulario-web/contenedor-web/contenedor-web.component';

@Component({
  selector: 'app-body-registro',
  templateUrl: './body-registro.component.html',
  styleUrls: ['./body-registro.component.css']
})
export class BodyRegistroComponent implements OnInit {

  flgMostrarRegExp = false;
  flgMostrarRegOtr = false;
  flgSoloLectura = false;
  flgMostrarFormWeb = false;

  @ViewChild(BodyDatosExpedienteComponent) bodyDatosExpedienteC: BodyDatosExpedienteComponent;
  @ViewChild(RegistroDocumentoComponent) registroDocumentoC: RegistroDocumentoComponent;
  @ViewChild(ContenedorWebComponent) contenedorWebC: ContenedorWebComponent;

  @Output() opRetornaRegistro = new EventEmitter();

  constructor(protected furService: FurService, ) { }

  ngOnInit() {
  }

  _Registrar() {

    if (this.flgMostrarRegExp) {

      if (!this.bodyDatosExpedienteC.ValidarDatos()) {

        // this.bodyDatosExpedienteC.GuardarDatos().subscribe({

        //   //complete() { this.EmitirDato(); }
        //   complete() {
        //     console.log("===========data");
        //     console.log(this);
        //   }

        // });

        this.bodyDatosExpedienteC.GuardarDatos().subscribe({
          complete() {}
        });


      }

      // (new Observable(this.bodyDatosExpedienteC.GuardarDatos)).subscribe({

      //   complete() { this.EmitirDato(); }//para retornar a la interfaz anterior

      //   }

      // );

    } else if (this.flgMostrarRegOtr) {

      if (!this.registroDocumentoC.ValidarDatos()) {

        // this.registroDocumentoC.GuardarDatos().subscribe({

        //   complete() { this.EmitirDato(); }

        // });

        this.registroDocumentoC.GuardarDatos().subscribe({
          complete() {}
        });

      }


    }

    // this.EmitirDato();

  }

  _GuardadoExpediente() {

    // console.log("=====emitir1");

    // this.EmitirDato();
    this.bodyDatosExpedienteC.soloLectura(true);
    this.flgSoloLectura = true;

  }

  _GuardadoDocumento() {

    // console.log("=====emitir1");

    // this.EmitirDato();
    this.registroDocumentoC.soloLectura(true);
    this.flgSoloLectura = true;

  }

  _Cancelar() {

    this.EmitirDato();

  }

  EmitirDato() {

    this.opRetornaRegistro.emit(false);

  }

  MostrarRegistro(idOpcion: number, idFur: number, flgSoloLectura: boolean) {


  }



}
